import type React from 'react'
import { useCallback } from 'react'

import { getLogoutUrl } from '@/client/services/url'
import { broadcastLogout } from '@/client/utils/logoutBroadcast'

import ShwLink, { type ShwLinkProps } from '@/components/ShwLink'

type LogoutLinkProps = Omit<ShwLinkProps, 'href'>

export default function LogoutLink({ onClick, ...props }: LogoutLinkProps): React.ReactElement {
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      broadcastLogout()
      onClick?.(e)
    },
    [onClick]
  )

  return <ShwLink href={getLogoutUrl()} onClick={handleClick} {...props} />
}
